// 콘텐츠, 챌린지, 체크

import { apiClient } from "./axios";

const challengeList = async ({ page }) => {
  try {
    const res = await apiClient.get(
      `/api/v1/admin/challenge/list?page=${page}`
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const challengeCreate = async ({
  challengeTitle,
  challengeCertification,
  challengeFrequency,
  challengeDaily,
  challengeMax,
  challengeAuthCnt,
  challengeIcon,
  challengeAuthDescription,
  challengeDescription,
  challengeStart,
  challengeEnd,
  IsPrivate,
  ChallengeWeeklyAuth,
  challengeType,
  challengeWeek
}) => {
  try {
    console.log(challengeType,
  challengeWeek)
    const res = await apiClient.post("/api/v1/admin/challenge/create", {
      challenge_title: challengeTitle,
      challenge_certification: challengeCertification,
      challenge_frequency: challengeFrequency,
      challenge_daily: challengeDaily,
      challenge_max: challengeMax,
      challenge_auth_cnt: challengeAuthCnt,
      challenge_icon: challengeIcon,
      challenge_auth_description: challengeAuthDescription,
      challenge_description: challengeDescription,
      challenge_start: challengeStart,
      challenge_end: challengeEnd,
      is_private: IsPrivate,
      challenge_weekly_auth: ChallengeWeeklyAuth,
      challenge_type: challengeType,
      challenge_week: challengeWeek,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const challengeUpdate = async ({
  id,
  challengeTitle,
  challengeCertification,
  challengeFrequency,
  challengeDaily,
  challengeMax,
  challengeAuthCnt,
  challengeIcon,
  challengeAuthDescription,
  challengeDescription,
  challengeStart,
  challengeEnd,
  IsPrivate,
  ChallengeWeeklyAuth,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/challenge/update", {
      id: id,
      challenge_title: challengeTitle,
      challenge_certification: challengeCertification,
      challenge_frequency: challengeFrequency,
      challenge_daily: challengeDaily,
      challenge_max: challengeMax,
      challenge_auth_cnt: challengeAuthCnt,
      challenge_icon: challengeIcon,
      challenge_auth_description: challengeAuthDescription,
      challenge_description: challengeDescription,
      challenge_start: challengeStart,
      challenge_end: challengeEnd,
      is_private: IsPrivate,
      challenge_weekly_auth: ChallengeWeeklyAuth,
    });
    console.log(ChallengeWeeklyAuth, res);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const challengeDelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/challenge/delete", {
      challenge_id: id,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const expertQAList = async ({ page }) => {
  try {
    const res = await apiClient.get(`/api/v1/admin/qna/list?page=${page}`);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const expertQADelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/qna/delete", {
      qa_id: id,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const expertQACommentCreate = async ({
  id,
  qaComment,
  qaCommentReferImage,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/qna/comment/create", {
      qa_id: id,
      qa_comment: qaComment,
      qa_comment_refer_image: qaCommentReferImage,
    });
    console.log(res);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const expertQACommentList = async ({ id }) => {
  try {
    const res = await apiClient.get(
      `/api/v1/admin/qna/comment/list?qa_id=${id}`
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const expertQACommentDelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/qna/comment/delete", {
      id: id,
    });
    console.log(res, "111");
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const expertQACommentUpdate = async ({
  id,
  qaComment,
  qaCommentReferImage,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/qna/comment/update", {
      id: id,
      qa_comment: qaComment,
      qa_comment_refer_image: qaCommentReferImage,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentsList = async ({ page }) => {
  try {
    const res = await apiClient.get(
      `/api/v1/admin/content/list?page=${page}&type=content`
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};
const UsersList = async ({ page }) => {
  try {
    const res = await apiClient.get(
      `/api/v1/admin/user/list?page=${page}`
    );
    console.log(res)
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};
const shortsList = async ({ page }) => {
  try {
    const res = await apiClient.get(
      `/api/v1/admin/content/list?page=${page}&type=shorts`
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentsCreate = async ({
  contentTitle,
  contentDescription,
  contentBackgroundImage,
  contentThumbnail,
  contentSummary,
  contentType,
  contentBinaryType,
  contentVideoLink,
  authorId,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/content/create", {
      content_title: contentTitle,
      content_description: contentDescription,
      content_type: contentType,
      content_summary:contentSummary,
      content_binary_type: contentBinaryType,
      content_video_link: contentVideoLink,
      content_thumbnail: contentThumbnail,
      author_id: authorId,
      content_background_image: contentBackgroundImage,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};


const contentsUpdate = async ({
  id,
  contentTitle,
  contentDescription,
  contentType,
  contentBinaryType,
  contentVideoLink,
  contentGroupId,
    contentInnerTag,
  contentTag,
  contentThumbnail,
  contentSummary,
  contentBackgroundImage,
}) => {
  try {
    console.log(id)
    const res = await apiClient.post("/api/v1/admin/content/update", {
      id: id,
      content_title: contentTitle,
      content_description: contentDescription,
      content_type: contentType,
      content_binary_type: contentBinaryType,
      content_video_link: contentVideoLink,
      content_group_id: contentGroupId,
      content_inner_tag: contentInnerTag,
      content_thumbnail: contentThumbnail,
      contentTag: contentTag,
      content_summary: contentSummary,
      content_background_image: contentBackgroundImage,
    });
    console.log(res);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentsDelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/content/delete", {
      content_id: id,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentsAuthorList = async () => {
  try {
    const res = await apiClient.get(
      "/api/v1/admin/content/admin/list"
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentsGroupCreate = async ({
  contentGroupName,
  groupThumbnail,
  groupTag,
}) => {
  try {
    const res = await apiClient.post(
      "/api/v1/admin/content/group/create/temporary",
      {
        content_group_name: contentGroupName,
        group_thumbnail: groupThumbnail,
        group_tag: groupTag,
      }
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentsImageUpload = async ({ base64Image }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/content/image/temporary", {
      image: base64Image,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};
const updateRecommend = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/pick/update", { contentId: id });
    if (!res.data?.status) {
      console.error(res.data?.error || "Unknown error occurred");
      return { IsError: true, error: res.data?.error || "Failed to update recommend state." };
    }
    return { IsError: false, data: res.data }; // 성공 시 상태와 데이터 반환
  } catch (error) {
    console.error(error);
    return { IsError: true, error: error.message || "Network error occurred." };
  }
};
const servayList = async ({ page }) => {
  try {
    const res = await apiClient.get(`/api/v1/admin/user/servay/list`);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const servayResultList = async ({user_id,servay_id}) => {
  try {
    const res = await apiClient.get(`/api/v1/admin/user/servay?user_id=${user_id}&servay_id=${servay_id}`);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};
const binaryContentsHooks = {
  challengeList,
  challengeCreate,
  challengeUpdate,
  challengeDelete,
  expertQAList,
  expertQADelete,
  expertQACommentList,
  expertQACommentCreate,
  expertQACommentUpdate,
  expertQACommentDelete,
  contentsList,
  contentsCreate,
  contentsDelete,
  contentsGroupCreate,
  // contentsGroupList,
  contentsUpdate,
  contentsImageUpload,
  updateRecommend,
  shortsList,
  UsersList,
  servayList,
  servayResultList,
  contentsAuthorList
};
export default binaryContentsHooks;
